import React from 'react';
import './ActionBar.scss';

// ---------- ActionButton ----------

interface ActionButtonProps {
    variant?: 'primary' | 'secondary' | 'active' | 'default';
    icon?: React.ReactNode;
    disabled?: boolean;
    onClick: () => void;
    children: React.ReactNode;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
    variant = 'default',
    icon,
    disabled,
    onClick,
    children,
}) => {
    const cls = ['btn-action'];
    if (variant !== 'default') cls.push(variant);

    return (
        <button className={cls.join(' ')} disabled={disabled} onClick={onClick}>
            {icon}
            <span>{children}</span>
        </button>
    );
};

// ---------- ActionBar ----------

interface ActionBarProps {
    children: React.ReactNode;
    className?: string;
    colorScheme?: 'default' | 'warn' | 'warn-active';
}

export const ActionBar: React.FC<ActionBarProps> = ({
    children,
    className,
    colorScheme = 'default',
}) => {
    const cls = ['action-bar'];
    if (colorScheme === 'warn') cls.push('color-warn');
    if (colorScheme === 'warn-active') cls.push('color-warn-active');
    if (className) cls.push(className);

    return <div className={cls.join(' ')}>{children}</div>;
};
